import { IsInt, IsNotEmpty, IsNumber, IsOptional, IsString, Min } from 'class-validator'

export class GenerateMissionTicketDto {
  // The date correctly formatted when the truck arrives at the field
  @IsString()
  @IsNotEmpty()
  truckFieldArrivalDate!: string

  @IsString()
  @IsOptional()
  comment?: string

  @IsNumber()
  @Min(1)
  @IsInt()
  truckId!: number

  @IsNumber()
  @Min(1)
  @IsInt()
  cropId!: number

  @IsNumber()
  @Min(1)
  @IsInt()
  harvestTeamId!: number

  @IsNumber()
  @Min(1)
  @IsInt()
  @IsOptional()
  factoryId?: number
}
